export const iconFontAwesomeMoneyMoneyBillWheat = (
	<i className="fa-solid fa-money-bill-wheat"></i>
);
